@import "../../global/normalize.css";

/**
 * @prop --ic-z-index-toast: z-index of toast
 */

@media (prefers-reduced-motion: no-preference) {
  :host {
    animation: fadein var(--ic-transition-duration-slow) ease-in-out;
  }

  :host(.hidden) {
    animation: fadeout var(--ic-transition-duration-slow) ease-in-out;
  }
}

:host {
  --bottom-position: var(--ic-space-xl);

  position: fixed;
  bottom: var(--bottom-position);
  left: 50%;
  transform: translate(-50%);
  z-index: var(--ic-z-index-toast);
}

:host(.ic-toast-hidden) {
  display: none;
}

:host(:focus) {
  outline: none;
}

.container {
  max-width: 32.5rem;
  min-width: 18rem;
  box-shadow: var(--ic-elevation-overlay);
  min-height: 3.5rem;
  background-color: var(--ic-toast-background);
  display: flex;
  align-items: center;
  position: relative;
  border: var(--ic-space-1px) solid var(--ic-color-border-neutral-grey);
  border-radius: var(--ic-border-radius);
}

.toast-icon-container {
  height: 100%;
  display: flex;
  align-items: center;
}

.container-neutral {
  border-color: var(--ic-toast-status-neutral);
}

.container-info {
  border-color: var(--ic-toast-status-info);
}

.container-warning {
  border-color: var(--ic-toast-status-warning);
}

.container-error {
  border-color: var(--ic-toast-status-error);
}

.container-success {
  border-color: var(--ic-toast-status-success);
}

.container-ai {
  border-color: var(--ic-toast-status-ai);
}

.divider {
  height: 100%;
  width: var(--ic-space-xs);
  position: absolute;
  border-radius: 0;
}

.divider-neutral {
  background-color: var(--ic-toast-status-neutral);
}

.divider-info {
  background-color: var(--ic-toast-status-info);
}

.divider-warning {
  background-color: var(--ic-toast-status-warning);
}

.divider-error {
  background-color: var(--ic-toast-status-error);
}

.divider-success {
  background-color: var(--ic-toast-status-success);
}

.divider-ai {
  background-color: var(--ic-toast-status-ai);
}

.toast-icon,
::slotted(svg) {
  height: var(--ic-space-lg);
  width: var(--ic-space-lg);
  margin-left: var(--ic-space-md);
}

:host(.ic-toast-variant-neutral) .toast-icon svg,
::slotted(svg) {
  fill: var(--ic-toast-icon-neutral);
}

:host(.ic-toast-variant-info) .toast-icon svg {
  fill: var(--ic-toast-icon-info);
}

:host(.ic-toast-variant-warning) .toast-icon svg {
  fill: var(--ic-toast-icon-warning);
}

:host(.ic-toast-variant-error) .toast-icon svg {
  fill: var(--ic-toast-icon-error);
}

:host(.ic-toast-variant-success) .toast-icon svg {
  fill: var(--ic-toast-icon-success);
}

:host(.ic-toast-variant-ai) .toast-icon svg {
  fill: var(--ic-toast-icon-ai);
}

.toast-content {
  margin-left: var(--ic-space-xs);
  width: 100%;
}

.no-icon {
  margin-left: var(--ic-space-md);
}

.toast-text {
  padding: var(--ic-space-xs) var(--ic-space-xs) var(--ic-space-xs) 0;
}

.toast-heading {
  --ic-typography-color: var(--ic-toast-title);
}

.toast-message {
  --ic-typography-color: var(--ic-toast-description);
}

.toast-action-container {
  padding-bottom: var(--ic-space-md);
}

#dismiss-button {
  padding: var(--ic-space-xs);
}

#dismiss-button > svg {
  color: var(--ic-toast-dismiss-button);
}

ic-loading-indicator {
  --outer-color: transparent;
  --inner-color: var(--ic-action-monochrome);
}

.toast-dismiss-timer {
  padding: var(--ic-space-sm);
}

@media (max-width: 576px) {
  :host {
    --bottom-position: var(--ic-space-lg);

    width: calc(100% - 2 * var(--ic-space-md));
  }
}

@media (min-width: 993px) {
  :host {
    --bottom-position: calc(var(--ic-space-xl) + var(--ic-space-xs));
  }
}

@media (forced-colors: active) {
  .container {
    border: var(--ic-border-hc);
  }
}

@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }

  to {
    bottom: var(--bottom-position);
    opacity: 1;
  }
}

@keyframes fadeout {
  from {
    bottom: var(--bottom-position);
    opacity: 1;
  }

  to {
    bottom: 0;
    opacity: 0;
  }
}
